import { Module, ResourceModule, VersionsModule } from 'projects/access-control/src/app/Domain/Entities/module.interface';
import { Pagination } from 'projects/access-control/src/app/Domain/Entities/pagination.interface';
import { DataPagination } from '../../../Domain/Adapters';
export const SYSTEMS_MODULE_STATE_NAME = 'module';

export interface SystemsModuleState {
	modules: Module[];
	pagination: DataPagination;
	error: any;
	loading: boolean;
	dataResources: ResourceModule;
	dataVersions: VersionsModule;
	loadingResources: boolean;
	loadingVersions: boolean;
}

export const initialStateModule: SystemsModuleState = {
	modules: [],
	pagination: {} as DataPagination,
	dataResources: {
		pagination: {} as DataPagination,
		resource: [],
		paginationIni: {} as Pagination,
	} as ResourceModule,
	dataVersions: {
		pagination: {} as DataPagination,
		versions: [],
		paginationIni: {} as Pagination,
	} as VersionsModule,
	error: null,
	loading: false,
	loadingResources: false,
	loadingVersions: true,
};
